import React from "react";
import {
  Control,
  FieldPath,
  FieldValues,
  PathValue,
  RegisterOptions,
  useController,
} from "react-hook-form";
import { Col, Form, FormControlProps } from "react-bootstrap";

interface Props<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>
> extends FormControlProps {
  autocomplete?: string;
  min?: number;
  max?: number;
  label?: string;
  accept?: string;
  component?: React.FC;
  xs?: string | number;
  lg?: string | number;
  md?: string | number;
  xl?: string | number;
  sm?: string | number;
  rows?: number;
  label_class?: string;
  group_class?: string;
  children?: React.ReactElement;
  name: TName | any;
  control: Control<TFieldValues>;
  rules?: RegisterOptions<TFieldValues, TName>;
  defaultValue?: PathValue<TFieldValues, TName>;
  step?: string;
  labelElement?: React.ReactElement;
}

function Input<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>
>({
  component,
  lg,
  xs,
  sm,
  md,
  xl,
  label,
  label_class,
  group_class,
  name,
  control,
  children,
  rules,
  defaultValue,
  labelElement,
  ...rest
}: Props<TFieldValues, TName>) {
  const {
    field,
    fieldState: { invalid, error },
  } = useController({
    name,
    control,
    rules,
    defaultValue: defaultValue,
  });

  return (
    <Form.Group
      xs={xs}
      sm={sm}
      md={md}
      lg={lg}
      xl={xl}
      as={Col}
      className={group_class}
    >
      {label ? <Form.Label className={label_class}>{label}</Form.Label> : null}

      {labelElement ? labelElement : null}

      <Form.Control {...rest} {...field} isInvalid={invalid} />

      <Form.Control.Feedback type="invalid">
        {error?.message}
      </Form.Control.Feedback>

      {children ? children : null}
    </Form.Group>
  );
}

export default Input;
